import script from "./MainRequestListView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRequestListView.vue?vue&type=script&setup=true&lang=js"

import "./MainRequestListView.vue?vue&type=style&index=0&id=0f7a4892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7a4892"]])

export default __exports__